// extracted by mini-css-extract-plugin
module.exports = {"mask":"_5D2XM0o3","loader":"_5D3mY2A9"};